import { render, staticRenderFns } from "./studentStatisticsByClass.vue?vue&type=template&id=df15eeac"
import script from "./studentStatisticsByClass.vue?vue&type=script&lang=js"
export * from "./studentStatisticsByClass.vue?vue&type=script&lang=js"
import style0 from "./studentStatisticsByClass.vue?vue&type=style&index=0&id=df15eeac&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports